import SEO from '@/components/helper/seo';
import ContentHeadline from '@/components/content/headline';
import appConfig from '../../app.config';

export default function Impressum() {
  return (
    <>
      <SEO
        title="Impressum | CharterCheck"
        description="Hier finden Sie unser Impressum. Bei Fragen wenden Sie sich gerne jederzeit an unserer Servicehotline | Ihr Partner des ADAC"
      />
      <div className="max-w-7xl mx-auto mt-header pt-10 px-6 xl:px-0">
        <div className="grid md:grid-cols-2 gap-6 mb-10">
          <div>
            <ContentHeadline tag={1}>Impressum</ContentHeadline>
            <b>CharterCheck GmbH</b>
            <br />
            Würmstr. 4, 82319 Starnberg/München, Deutschland
            <br />
            <br />

            Geschäftsführer: Martin Kötje
            <br />
            Registergericht: Amtsgericht München
            <br />
            Registernummer: HRB 185227
            <br />
            USt.-Identifikations-Nr: DE271073545
            <br />
            <br />

            Telefon:
            {' '}
            {appConfig.phone}
            <br />
            E-Mail: booking@chartercheck.com
            <br />
          </div>
          <div>
            <ContentHeadline>Haftungshinweis</ContentHeadline>
            Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für
            den
            Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
          </div>
        </div>

      </div>
    </>
  );
}
